import { useState, useEffect } from "react";
import * as API from '../../../framework/API/api'
import { ENTITYNAME, MEDIACATEGORIES } from "../../../framework/constant/constant";
import RoundButton from "../../../framework/forms/helpercomponents/buttons/RoundButton";
import { utility } from "../../../framework/utility/utilityProvider";
import Box from '@mui/material/Box';
import MetaDataTab from "../manageContent/component/metaDataTab";

const ManageNodeTreeViewEditPanel = (props) => {

    const { selectedItem = {}, setSelectedItem, mainStyle, transcodeStatus, gridData, setGridData } = props;

    const entityName = selectedItem?.mediaEpisode?.MediaCategory?.SID == MEDIACATEGORIES.Series ? ENTITYNAME.Series : selectedItem?.mediaEpisode?.MediaCategory?.SID == MEDIACATEGORIES.Season ? ENTITYNAME.Season : ENTITYNAME.MediaEpisode;

    const [mediaData, setMediaData] = useState({});

    useEffect(() => {
        loadMetaData();
    }, [selectedItem]);

    const loadMetaData = async () => {
        let metaData = {}
        const res = await API.getData(entityName, { query: ['_id', '=', selectedItem?.mediaEpisode?._id] });
        if (res.success) {
            metaData = res.success && res.data.length > 0 ? res.data[0] : {};
        }
        setMediaData(metaData);
    };

    const defaultStyle = {
        position: "absolute",
        padding: "10px",
        top: "91px",
        right: 0,
        width: "500px",
        height: "76%",
        backgroundColor: "white",
        transition: 'all 0.3s linear'
    };

    return (
        <div style={{ ...defaultStyle, ...mainStyle }} >
            <div style={{ display: "flex", marginBottom: "28px", marginTop: "10px", height: "180px" }}>
                <img src={mediaData?.ImageUrl} onError={
                    (e) => {
                        e.target.onerror = null;
                        e.target.src = 'https://i.postimg.cc/j5PsF5jZ/defaultmovie.png';
                    }
                } style={{ height: "165px", minWidth: "180px", maxWidth: "180px", borderRadius: "5px", objectFit: "cover" }} className="card-img-top" alt={mediaData?.Title} />
                <div className="ml-3" style={{ height: "140px", width: "100%" }}>
                    <div className="flex-container">
                        <h1 style={{ marginTop: '0px' }}>{utility.subString(mediaData?.Title, 15)}</h1>
                        <div className="flex-container-reverse flex-item-auto">
                            <RoundButton icon={"close"} title={"Close"} onClick={() => setSelectedItem({})} />
                        </div>
                    </div>
                    <p className="pl-1 mb-1">{mediaData?.AssetId}</p>
                    <p className="pl-1 mb-1">{mediaData?.Description?.length > 90 ? mediaData?.Description?.substring(0, 60) + '...' : selectedItem?.Description}</p>
                    <p className="pl-1 mb-1">{utility.displayArrayInPipe(mediaData?.Genres, 'Description')}</p>
                    <div style={{ display: "flex" }}>
                        <p style={{ display: "flex", justifyContent: "center", alignItems: "center" }} className="pl-1 mb-1 mr-3">
                            Transcode Status :
                        </p>
                        <p style={{ width: "auto", fontSize: "12px", display: "flex", justifyContent: "center", alignItems: "center", backgroundColor: transcodeStatus == 'Complete' ? 'green' : "grey", color: "white", borderRadius: "5px", padding: "2px 5px" }} className="pl-1 mb-1">{transcodeStatus}</p>
                    </div>
                    <div style={{ display: "flex" }}>
                        <p style={{ display: "flex", justifyContent: "center", alignItems: "center" }} className="pl-1 mb-1 mr-3">
                            Duration :
                        </p>
                        <p style={{ width: "auto", fontSize: "12px", display: "flex", justifyContent: "center", alignItems: "center", backgroundColor: utility.convertMilisecondsToStringWithFrames(mediaData?.Duration) == '00:00:00' ? 'red' : "grey", color: "white", borderRadius: "5px", padding: "2px 5px" }} className="pl-1 mb-1">{utility.convertMilisecondsToStringWithFrames(mediaData?.Duration)}</p>
                    </div>
                </div>
            </div>
            <div>
                <label>MetaData</label>
                <Box sx={{
                    width: '100%', typography: 'body1', overflow: 'auto',
                    height: "45vh",
                    padding: '0px 10px 0px 10px'
                }}>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                        <MetaDataTab entityName={entityName} mediaEpisode={mediaData} gridData={gridData} setGridData={setGridData} isNodeBrowser={true} selectedItem={selectedItem} />
                    </Box>
                </Box>
            </div>
        </div>
    )
}

export default ManageNodeTreeViewEditPanel